
/**
 * Module dependencies.
 */

import { applications } from './applications';
import { colors } from './colors';
import { effects } from './effects';
import { finishesValues } from './finishes';
import { functions } from './functions';
import { hueVariation } from './hue-variations';
import { slipResistanceValues } from './slip-resistance';
import { surfaces } from './surfaces';
import { trafficLevel } from './traffic-level';
import { typologiesValues } from './typologies';

/**
 * Export `availableFiltersKeys`.
 */

export const availableFiltersKeys = {
  application: 'application',
  collectionsAll: 'id',
  collectionsNew: 'id',
  color: 'color',
  effect: 'effect',
  finish: 'finish',
  format: 'format',
  function: 'function',
  hueVariation: 'hue_variation',
  slipResistance: 'slip_resistance',
  surface: 'surface',
  thickness: 'thickness',
  trafficLevel: 'traffic_level',
  typology: 'typology'
} as const;

/**
 * Export `availableFiltersValues`.
 */

export const availableFiltersValues = {
  ...slipResistanceValues,
  [availableFiltersKeys.application]: Object.values(applications),
  [availableFiltersKeys.color]: Object.values(colors),
  [availableFiltersKeys.effect]: Object.values(effects),
  [availableFiltersKeys.finish]: Object.values(finishesValues),
  [availableFiltersKeys.function]: Object.values(functions),
  [availableFiltersKeys.hueVariation]: Object.values(hueVariation),
  [availableFiltersKeys.surface]: Object.values(surfaces),
  [availableFiltersKeys.trafficLevel]: Object.values(trafficLevel),
  [availableFiltersKeys.typology]: Object.values(typologiesValues)
};

/**
 * Export `availableFiltersKeysPlural`.
 */

export const availableFiltersKeysPlural = {
  [availableFiltersKeys.application]: 'applications',
  [availableFiltersKeys.color]: 'colors',
  [availableFiltersKeys.effect]: 'effects',
  [availableFiltersKeys.finish]: 'finishes',
  [availableFiltersKeys.format]: 'formats',
  [availableFiltersKeys.function]: 'functions',
  [availableFiltersKeys.typology]: 'typologies'
} as const;
